<svg class="{{color}} {{icon.includes('-small') ? 'sm' : 'lg'}} {{iconClass}}" aria-hidden="true"><use [attr.href]="iconMap[icon] + '#' + icon"></use></svg>
